import TipTapHeading from '@tiptap/extension-heading'
import { textblockTypeInputRule } from '@tiptap/core'

const levelToTextSize: { [key in number]: string } = {
  1: "text-5xl/16",
  2: "text-4xl",
  3: "text-3xl",
  4: "text-2xl",
  5: "text-xl",
  6: "text-lg",
}

export const Heading = TipTapHeading.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        class: "relative font-bold mb-6 editor-placeholder"
      },
    }
  },
  addAttributes() {
    return {
      ...this.parent?.(),
      id: {
        default: null,
        parseHTML: (element) => {
          return element.getAttribute('id')
        },
        renderHTML: (attributes) => {
          return {
            id: attributes.blockId || attributes.id,
            class: levelToTextSize[attributes.level || 1],
          }
        },
      },
    }
  },
  addInputRules() {
    // Lower levels threshold: # = h2, ## = h3, ### = h4.
    const levelsWithoutH1 = this.options.levels.filter((option) => option !== 1)

    return levelsWithoutH1.map((level) => {
      return textblockTypeInputRule({
        find: new RegExp(`^(#{${level - 1},${level - 1}})\\s$`),
        type: this.type,
        getAttributes: {
          level,
        },
      })
    })
  },
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const { selection } = editor.state
        const { $from } = selection

        // Check if we're in a heading level 1
        if ($from.parent.type.name === 'heading' && $from.parent.attrs.level === 1) {
          // Check if cursor is at the end of the heading
          const isAtEnd = $from.pos === $from.end();

          if (isAtEnd) {
            return editor
              .chain()
              .insertContentAt($from.after(), {type: "paragraph"})
              .focus($from.after() + 1)
              .run()
          } else {
            // Split the block and set the new node to paragraph.
            // This will create a new paragraph after the heading
            // with the heading's content (if applicable).
            return editor
              .chain()
              .splitBlock()
              .setNode('paragraph')
              .run()
          }
        }

        // Let the default Enter behavior happen for other nodes
        return false
      },
    }
  },
})
